import "./Header.scss";
import Contacts from "../../UI/Contacts/Contacts";
import Nav from "../../UI/Nav/Nav";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header__wrapper">
          <Link className="header__logo" to="/">
            <span className="header__logo-icon">&lt;C/&gt;</span>
            <span className="header__logo-brand">artCode.dev</span>
          </Link>

          <Nav />

          <Contacts />
        </div>
      </div>
    </header>
  );
};


export default Header;